/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_No_ActivityInputs */

const en_dashboard_no_activity = /** @type {(inputs: Dashboard_No_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No recent activity yet`)
};

const de_dashboard_no_activity = /** @type {(inputs: Dashboard_No_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Aktivitaeten`)
};

const fr_dashboard_no_activity = /** @type {(inputs: Dashboard_No_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas encore d'activite recente`)
};

const es_dashboard_no_activity = /** @type {(inputs: Dashboard_No_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin actividad reciente aun`)
};

const it_dashboard_no_activity = /** @type {(inputs: Dashboard_No_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna attivita recente`)
};

const nl_dashboard_no_activity = /** @type {(inputs: Dashboard_No_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen recente activiteit`)
};

const pl_dashboard_no_activity = /** @type {(inputs: Dashboard_No_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak ostatniej aktywnosci`)
};

const fi_dashboard_no_activity = /** @type {(inputs: Dashboard_No_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei viimeaikaista toimintaa vielä`)
};

const da_dashboard_no_activity = /** @type {(inputs: Dashboard_No_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen nylig aktivitet endnu`)
};

const sv_dashboard_no_activity = /** @type {(inputs: Dashboard_No_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen senaste aktivitet annu`)
};

/**
* | output |
* | --- |
* | "No recent activity yet" |
*
* @param {Dashboard_No_ActivityInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_no_activity = /** @type {((inputs?: Dashboard_No_ActivityInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_No_ActivityInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_no_activity(inputs)
	if (locale === "fr") return fr_dashboard_no_activity(inputs)
	if (locale === "es") return es_dashboard_no_activity(inputs)
	if (locale === "it") return it_dashboard_no_activity(inputs)
	if (locale === "nl") return nl_dashboard_no_activity(inputs)
	if (locale === "pl") return pl_dashboard_no_activity(inputs)
	if (locale === "fi") return fi_dashboard_no_activity(inputs)
	if (locale === "da") return da_dashboard_no_activity(inputs)
	if (locale === "sv") return sv_dashboard_no_activity(inputs)
	return en_dashboard_no_activity(inputs)
});